import Image from "next/image";
import type { SupportedLanguage } from "@/lib/shared";
import lang from "./lang.json";

/** نفس صورة/نص لوحة التقديم اليسرى — تظهر أعلى المحتوى على الشاشات الصغيرة حيث تكون اللوحة المثبتة مخفية. */
export default function ApplyJobMobileHero({
  locale,
}: {
  locale: SupportedLanguage;
}) {
  return (
    <div className="relative z-10 h-44 w-full shrink-0 overflow-hidden md:hidden">
      <div className="absolute inset-0">
        <Image
          src="/images/applyjob-bg.webp"
          alt={lang["apply-job"][locale]}
          fill
          priority
          className="object-cover"
          sizes="100vw"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
      </div>
      <div className="relative z-10 flex h-full flex-col justify-end px-6 pb-6">
        <h2 className="mb-1 text-xl font-bold text-white">
          {lang["apply-job"][locale]}
        </h2>
        <p className="text-sm text-white/90">{lang["begin-application"][locale]}</p>
      </div>
    </div>
  );
}
